import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../gd-components/gd-popover/popover";

export default function FieldFormula_Popover(props:any) {
    return (
        <Popover popoverClass="gd-field-formula-edit-popover"
                 className="gd-field-formula-edit-popover-container"
                 attachment='top center'
                 targetAttachment='bottom center'
                 attachmentType='horizontal'
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            {props.field.getFormulaWithValues(props.model)}

        </Popover>
    )
}
